import styled from "styled-components";

export const StyledStepContainer = styled.div`
  background: var(--primary);
  clip-path: polygon(
    0% 5%,
    95% 5%,
    95% 0%,
    100% 50%,
    95% 100%,
    95% 95%,
    0% 95%
  );
  padding: 2px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
  margin-bottom: 20px;

  @media only screen and (max-width: 450px) {
    clip-path: polygon(
      0% 5%,
      93% 5%,
      93% 0%,
      100% 50%,
      93% 100%,
      93% 95%,
      0% 95%
    );
  }
`;

export const StyledStepWide = styled.div`
  background: white;
  clip-path: polygon(
    0% 5%,
    95.1% 5%,
    95.1% 0%,
    99.9% 50%,
    95.1% 100%,
    95.1% 95%,
    0% 95%
  );
  height: 50px;
  width: 100%;
  margin-left: 35px;

  @media only screen and (max-width: 450px) {
    clip-path: polygon(
      0% 5%,
      93.4% 5%,
      93.4% 0%,
      100% 50%,
      93.4% 100%,
      93.4% 95%,
      0% 95%
    );
    margin-left: 12px;
  }
`;

export const StyledStepWideArrow = styled.div<{ width: string }>`
  position: absolute;
  left: 2px;
  background: var(--primary);
  height: 50px;
  width: ${({ width }) => width};
`;

export const StyledLabel = styled.span<{ color: string }>`
  position: absolute;
  right: 20%;
  top: 12px;
  width: 19%;
  text-align: center;
  white-space: nowrap;
  color: ${({ color }) => color};
  z-index: 10;

  @media only screen and (max-width: 400px) {
    font-size: 14px;
  }
`;

export const StyledBackButton = styled.button`
  margin: 40px auto 0 !important;
  color: var(--primary);
  display: flex;
  align-items: center;
  font-weight: 700;
  font-size: 12px;
  @media only screen and (max-width: 400px) {
    font-size: 10px;
  }
  &:disabled {
    opacity: 0.65;
  }
  &:before {
    content: "";
    display: inline-block;
    margin-right: 10px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 11px 11px 11px 0;
    border-color: transparent var(--primary) transparent transparent;
  }
`;

export const StyledWrapper = styled.div`
  margin-bottom: 40px;
`;
